import classNames from 'classnames'
import { Logo, Text } from 'components/atoms'
import { useLoading } from 'stores'

export const Loading = () => {
  const isLoading = useLoading(state => state.isLoading)

  return (
    <div
      className={classNames({
        'w-full h-[100dvh] flex flex-col items-center justify-center gap-[60px]':
          true,
        hidden: !isLoading,
      })}
    >
      <div className="flex flex-col items-center justify-center">
        <Text
          className="!font-lineSeed !font-bold !text-lg !leading-[23.04px] text-white"
          text="上がる波AI×出玉解析"
        />
        <div className="w-full h-11 flex items-center justify-center">
          <Logo />
        </div>
      </div>
      <Text
        className="!font-lineSeed !font-bold !text-[17px] !leading-[27.37px] text-white"
        text="解析中. . . ."
      />
    </div>
  )
}
